import {
    Backdrop as MuiBackdrop,
    IconButton as UiIconButton,
    styled,
    styledForMobile,
    SIDEBAR_SPACING,
    SIDEBAR_SPACING_MOBILE,
} from "@l2r-front/l2r-ui"

import { TechniquesFilters as L2RTechniquesFilters } from "../TechniquesFilters"

export const Container = styled("div")(() => ({
    display: "flex",
    flex: 1,
    flexDirection: "column",
}))

export const TechniquesContainer = styledForMobile("div")(({ isMobile, theme }) => ({
    flexGrow: 1,
    backgroundColor: theme.palette["common/gray_states"].light,
    display: "flex",
    flexDirection: "column",
    position: "relative",
    padding: theme.spacing(4, isMobile ? SIDEBAR_SPACING_MOBILE : SIDEBAR_SPACING, 0, isMobile ? SIDEBAR_SPACING_MOBILE : SIDEBAR_SPACING),
}))

export const IconButton = styled(UiIconButton)(({ theme }) => ({
    marginLeft: "auto",
    height: "fit-content",
    zIndex: theme.zIndex.appBar + 2,
}))

export const TechniquesFilters = styledForMobile(L2RTechniquesFilters)(({ isMobile, theme }) => ({
    backgroundColor: theme.palette["common/white_states"].main,
    boxShadow: theme.customShadow("LCS/Shadow-simple"),
    display: "flex",
    flexDirection: "column",
    left: 0,
    marginLeft: !isMobile && theme.spacing(-8),
    marginRight: !isMobile && theme.spacing(-8),
    position: "absolute",
    right: 0,
    zIndex: theme.zIndex.appBar + 1,
}))

export const Header = styledForMobile("div")(({ theme, isMobile }) => ({
    padding: isMobile ? theme.spacing(0, 4, 6, 4) : theme.spacing(0, 8, 6, 8),
}))

export const DisplayedFiltersWrapper = styledForMobile("div")(() => ({
    display: "flex",
}))

export const BackdropFilter = styledForMobile(MuiBackdrop)(({ theme }) => ({
    backgroundColor: "transparent",
    cursor: "pointer",
    zIndex: theme.zIndex.mobileStepper,
}))

export const Wrapper = styled("div")({
    display: "flex",
    flexDirection: "column",
    position: "relative",
})